export const containerTypeColor = {
    casino: '#7367F0',
    zone: '#15C5C5',
    pit: '#D239BD',
    table: '#FF8D21',
    device: '#A1C2CC',
}
